import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch, authHeaders, authHeadersFormData } from './apiHelpers';

export interface SiteImage {
    siteImageId: number;
    uniqueSiteId: number;
    imageUrl: string;
    filename: string;
    file: File;
    base64: string;
}

export function useSiteImages(siteId: number) {
    return useQuery<SiteImage[], Error>({
        queryKey: ['siteImages', siteId],
        queryFn: () => apiFetch<SiteImage[]>(`api/SiteInfo/GetSiteImages?id=${siteId}`, {
            method: 'GET',
            headers: authHeaders()
        }),
        enabled: siteId > 0
    });
}

export function useAddSiteImage() {
    const queryClient = useQueryClient();
    return useMutation<void, Error, { siteId: number; data: FormData }>({
        mutationFn: ({ data }) => apiFetch<void>('api/SiteInfo/AddSiteImage', {
            method: 'POST',
            body: data,
            headers: authHeadersFormData()
        }),
        onSuccess: (_data, variables) => queryClient.invalidateQueries({ queryKey: ['siteImages', variables.siteId] })
    });
}

export function useDeleteSiteImage() {
    const queryClient = useQueryClient();
    return useMutation<void, Error, { siteId: number; url: string }>({
        mutationFn: ({ url }) => apiFetch<void>(`api/SiteInfo/DeleteSiteImage?url=${encodeURIComponent(url)}`, {
            method: 'DELETE',
            headers: authHeaders()
        }),
        onSuccess: (_data, variables) => queryClient.invalidateQueries({ queryKey: ['siteImages', variables.siteId] })
    });
}
